import { apiV2 } from '@/libs/axios/axios'

export const useSubscriptionsApi = () => {
  const getMySubscription = async () => {
    const { data } = await apiV2.get('/subscriptions/me')
    return data
  }

  return {
    getMySubscription,
  }
}
